import { createContext, useContext } from 'react';

export const PopupContext = createContext(null);

export const usePopupContext = () => useContext(PopupContext);
